import Vue from 'vue';
import VueRouter from 'vue-router';

import PublicRoutes from '@/pages/public/router';
import BaseRoutes from '@/pages/router';

import AuthService from '@/services/auth/auth.service';
import RouterService from '@/services/router/router.service.ts';

const authService = new AuthService();
const routerService = new RouterService();

Vue.use(VueRouter);

const routes = [
  ...BaseRoutes,
  ...PublicRoutes,
  {
    path: '*',
    redirect: '/login'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const isLogged = authService.isLogged();

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogged) {
      next({
        path: '/login',
      });
      return;
    }
  }

  if (to.matched.some(record => record.meta.onlyAnonymous)) {
    if (isLogged) {
      next({
        path: routerService.getHomeRoute(),
      });
      return;
    }
  }

  if (to.matched.some(record => record.meta.role)) {
    if (!authService.hasRole(to.matched[1].meta.role)) {
      next({
        path: routerService.getHomeRoute(),
      });
      return;
    }
  }

  if (to.path === '/') {
    next({
      path: routerService.getHomeRoute(),
    });
    return;
  }

  next();
});

export default router;
